import "#styles/visually-hidden.scss";
export interface Input {
  noArrow?: boolean;
}
<span class="visually-hidden">
  - opens in new window or tab
</span>
<if(!input.noArrow)>
  <sb-external/>
</if>
